/**
 * Language Store — Zustand store for i18n locale selection
 *
 * Persists to localStorage. Auto-detects browser language on first visit.
 */

import { create } from 'zustand';

export type Language = 'en' | 'de';

const STORAGE_KEY = 'artrouting_lang';

function detectLanguage(): Language {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === 'en' || stored === 'de') return stored;
    // Auto-detect from browser
    const browserLang = navigator.language || '';
    if (browserLang.startsWith('de')) return 'de';
  } catch {}
  return 'en';
}

interface LanguageState {
  language: Language;
  setLanguage: (lang: Language) => void;
}

export const useLanguageStore = create<LanguageState>((set) => ({
  language: detectLanguage(),
  setLanguage: (lang) => {
    try { localStorage.setItem(STORAGE_KEY, lang); } catch {}
    set({ language: lang });
  },
}));
